define('plugin/additional-fields/view/AdditionalFieldItemView',['require','__original__/AdditionalFieldItemView','view/helper/DatePicker'],function (require) {

    var Parent = require('__original__/AdditionalFieldItemView');
    var DatePicker = require('view/helper/DatePicker');

    /**
     * Additional field item view
     *
     * @class AdditionalFieldItemView
     */
    return Parent.extend({

        onRender: function () {
            console.log('here')
            if (this.model.get('type') === 'date') {
                if (this.ui.calendarToggle.length > 0) {
                    this._datePicker = DatePicker.initDatepicker(this.ui.calendarToggleInput);
                    this._datePicker.datepicker().on('changeDate changeMonth changeYear', this.onCalendarValueChange.bind(this));
                } else {
                    DatePicker.initDatepicker(this.ui.input, {
                        autoclose: true
                    });
                }
            }
        },

    });

});
